import DaraDateTimePicker from "./DateTimePicker";

import "../style/datetimepicker.style.scss";

export const DateTimePicker = DaraDateTimePicker;
